import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import { catchMarkerIcon } from '../../lib/leafletIcon';

interface Props {
  latitude: number;
  longitude: number;
  name: string;
}

export function SpotMiniMap({ latitude, longitude }: Props) {
  return (
    <div className="rounded-xl overflow-hidden" style={{ height: '220px' }}>
      <MapContainer
        center={[latitude, longitude]}
        zoom={13}
        style={{ height: '100%' }}
        dragging={false}
        scrollWheelZoom={false}
        doubleClickZoom={false}
        zoomControl={false}
        touchZoom={false}
        keyboard={false}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        />
        <Marker position={[latitude, longitude]} icon={catchMarkerIcon} />
      </MapContainer>
    </div>
  );
}
